import { ContentBox } from "@msuite/ui/app-shell";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { WarehouseLocationsMenu } from "@/components/stock";
import { client } from "@/hono";
import { WarehouseLocations } from "../warehouse-locations";
import { columns } from "./table-config";
import { WarehouseZonesMenu } from "./warehouse-zones-menu";

export function WarehouseZones() {
	/** Query */
	const { data, isLoading, refetch, queryKey } = useQuery({
		queryKey: ["warehouse-zones"],
		queryFn: async () => {
			const response = await client.stock["warehouse-zones"].$get();
			const data = await responseHandler(response);
			return data.warehouseZones;
		},
	});

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={data || []}
				columns={columns}
				refetch={refetch}
				isLoading={isLoading}
				queryKey={queryKey}
				menu={<WarehouseZonesMenu />}
				persistenceKey="warehouse-zones-table"
				getRowCanExpand={() => true}
				renderSubRows={(row) => {
					return (
						<WarehouseLocations
							variant="sub-table"
							query={{
								warehouseZoneId: row.original.id,
							}}
							menu={
								<WarehouseLocationsMenu
									query={{
										warehouseZoneId: row.original.id,
									}}
								/>
							}
						/>
					);
				}}
			/>
		</ContentBox>
	);
}
